module.exports = __webpack_public_path__ + "fonts/Raleway-ExtraLightItalic.005cfa6d.ttf";